import React, {useMemo} from "react";
import IconButton from "@mui/material/IconButton";
import {Clear, Search} from "@mui/icons-material";
import {InputAdornment, TextField} from "@mui/material";

function SearchBox({query, setQuery, label = ''}) {
    const close = useMemo(() => query !== '' ? <InputAdornment position="start"><IconButton color={'dark'} onClick={() => setQuery('')}><Clear /></IconButton></InputAdornment> : <InputAdornment position="start"><IconButton disabled><Search /></IconButton></InputAdornment>, [query, setQuery]);
    return (<TextField label={label} placeholder={label} variant="outlined" fullWidth={true} slotProps={{input: {startAdornment: close}}}
                       value={query} onChange={(e) => setQuery(e.target.value)}></TextField>);
}
export default SearchBox;